/**
 * @generated SignedSource<<79046e3ce933a131a8b7ba38a3bf16c5>>
 * @relayHash b72d5285d7750d849089af91967dd685
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e01360339416305ce958280bcb677844f30b9ecb59d2f476a43439459bd31db

import type { ConcreteRequest } from 'relay-runtime';
export type RelationSourceType = "user" | "%future added value";
export type RelationTargetType = "content" | "space" | "%future added value";
export type RelationType = "collaborator" | "favourite" | "touched" | "%future added value";
export type UpdateRelationInput = {
  relationName: RelationType;
  sourceKey: string;
  sourceStatus?: string | null | undefined;
  sourceType: RelationSourceType;
  sourceVersion?: number | null | undefined;
  targetKey: string;
  targetStatus?: string | null | undefined;
  targetType: RelationTargetType;
  targetVersion?: number | null | undefined;
};
export type useDraftSyncSetRelationMutation$variables = {
  input: UpdateRelationInput;
};
export type useDraftSyncSetRelationMutation$data = {
  readonly updateRelation: {
    readonly relationName: string;
    readonly sourceKey: string;
    readonly targetKey: string;
    readonly url: string;
  } | null | undefined;
};
export type useDraftSyncSetRelationMutation = {
  response: useDraftSyncSetRelationMutation$data;
  variables: useDraftSyncSetRelationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRelationPayload",
    "kind": "LinkedField",
    "name": "updateRelation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "targetKey"
      },
      {
        "kind": "ScalarField",
        "name": "sourceKey"
      },
      {
        "kind": "ScalarField",
        "name": "relationName"
      },
      {
        "kind": "ScalarField",
        "name": "url"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDraftSyncSetRelationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDraftSyncSetRelationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b72d5285d7750d849089af91967dd685",
    "id": "4e01360339416305ce958280bcb677844f30b9ecb59d2f476a43439459bd31db",
    "metadata": {},
    "name": "useDraftSyncSetRelationMutation",
    "operationKind": "mutation",
    "text": "mutation useDraftSyncSetRelationMutation($input:UpdateRelationInput!){updateRelation(input:$input){targetKey,sourceKey,relationName,url}}"
  }
};
})();

(node as any).hash = "2f841a75be5c10aa568f6dcd9e89a16d";

export default node;
